import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">

      <div className="container">

        {/* LOGO */}
        <Link
          className="navbar-brand fw-bold"
          to="/"
        >
          Free Online Tools
        </Link>

        {/* MOBILE BUTTON */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div
          className="collapse navbar-collapse"
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto">

            {/* HOME */}
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/"
              >
                Home
              </Link>
            </li>

            {/* FINANCE */}
            <li className="nav-item dropdown">

              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                Finance
              </span>

              <ul className="dropdown-menu">

                <li>
                  <Link
                    className="dropdown-item"
                    to="/emi-calculator"
                  >
                    EMI Calculator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/tax-calculator"
                  >
                    Tax Calculator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/percentage-calculator"
                  >
                    Percentage Calculator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/loan-eligibility"
                  >
                    Loan Eligibility
                  </Link>
                </li>

              </ul>
            </li>

            {/* UTILITY */}
            <li className="nav-item dropdown">

              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                Utility
              </span>

              <ul className="dropdown-menu">

                <li>
                  <Link
                    className="dropdown-item"
                    to="/age-calculator"
                  >
                    Age Calculator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/password-generator"
                  >
                    Password Generator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/qr-generator"
                  >
                    QR Generator
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/word-counter"
                  >
                    Word Counter
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/stopwatch"
                  >
                    Stopwatch
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/bmi-calculator"
                  >
                    BMI Calculator
                  </Link>
                </li>

              </ul>
            </li>

            {/* DEVELOPER */}
            <li className="nav-item dropdown">

              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                Developer
              </span>

              <ul className="dropdown-menu">

                <li>
                  <Link
                    className="dropdown-item"
                    to="/json-formatter"
                  >
                    JSON Formatter
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/jwt-decoder"
                  >
                    JWT Decoder
                  </Link>
                </li>

              </ul>
            </li>

            {/* PDF */}
            <li className="nav-item dropdown">

              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                PDF
              </span>

              <ul className="dropdown-menu">

                <li>
                  <Link
                    className="dropdown-item"
                    to="/merge-pdf"
                  >
                    Merge PDF
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/split-pdf"
                  >
                    Split PDF
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/image-to-pdf"
                  >
                    Image to PDF
                  </Link>
                </li>

              </ul>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}